import { ApolloClient, InMemoryCache } from "@apollo/client";

//prob env var this aswell
export const client = new ApolloClient({
  uri: "https://hbpakwf6.api.sanity.io/v1/graphql/production/default",
  cache: new InMemoryCache(),
});
